import { Loader } from '@lifebit-ai/lds'
import React from 'react'

import { LoadingWrapper } from 'core/Common.styles'
import { NoContent } from 'modules/resultsV2/components/FileContent/NoContent'
import { StyledSelect, TableWrapper, XLSViewerWrapper } from 'modules/resultsV2/components/FileContent/XLSViewer.styles'
import { useRenderXLSX } from 'modules/resultsV2/components/FileContent/hooks/useRenderXLSX'
import type { GetBinaryFileContentResponse } from 'services/results/types'

import { Wrapper } from './FileContents.styles'

export const XLSX_FILE_PREVIEW_TEST_ID = 'xls-viewer'

interface XLSViewerProps {
  data?: GetBinaryFileContentResponse
}

export const XLSViewer: React.FC<XLSViewerProps> = ({ data }) => {
  const { isLoading, sheetNames, selectedSheetName, setSelectedSheetName, tableHTML, error } = useRenderXLSX(data)

  // Processing the table data
  if (isLoading) {
    return (
      <LoadingWrapper>
        <Loader text="Loading table data..." />
      </LoadingWrapper>
    )
  }

  if (!tableHTML) return <NoContent />

  if (error) {
    return (
      <Wrapper>
        <pre>{error}</pre>
      </Wrapper>
    )
  }

  return (
    <XLSViewerWrapper data-testid={XLSX_FILE_PREVIEW_TEST_ID}>
      {sheetNames.length > 1 && (
        <StyledSelect
          label="Sheet"
          options={sheetNames.map(sheetName => ({ label: sheetName, value: sheetName }))}
          onChange={value => setSelectedSheetName(value as string)}
          value={selectedSheetName}
        />
      )}

      {tableHTML && <TableWrapper dangerouslySetInnerHTML={{ __html: tableHTML }} />}
    </XLSViewerWrapper>
  )
}
